import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToolSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m9.482 6.019.46-.186.026-.495L10.103 3h3.794l.133 2.305.028.5.467.186a6.768 6.768 0 0 1 1.687.965l.392.307.443-.224 2.056-1.034L21 9.292l-1.909 1.253-.417.273.071.495a6.837 6.837 0 0 1 0 1.967l-.071.495.417.274L21 15.302l-1.897 3.286-2.055-1.033-.444-.224-.392.306a6.769 6.769 0 0 1-1.687.966l-.467.185-.028.5-.133 2.306h-3.794l-.135-2.338-.028-.495-.46-.187a6.77 6.77 0 0 1-1.641-.959l-.392-.31L7 17.53l-2.103 1.058L3 15.302l1.981-1.3.415-.273-.068-.49a6.842 6.842 0 0 1 0-1.884l.067-.49-.415-.273L3 9.292l1.896-3.288L7 7.063l.448.224.392-.31a6.816 6.816 0 0 1 1.642-.96l.001.002Zm2.589 9.188a2.87 2.87 0 1 0 0-5.74 2.87 2.87 0 0 0 0 5.74Z",
		stroke: "currentColor",
		strokeWidth: 1.568
	})
});
export default SvgToolSettings;
